import * as React from 'react';
import driverinfosecurity from '../../utils/DriverInfoSecurity';
import { LANGUAGE } from '../../constants/storageKeys';
import * as i18next from 'i18next';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Spinner from '../Controls/Spinner';
import { useSiteInfoDetails } from '../../hooks/useSiteDetails';
import { useSendFeedbackMessage } from '../../hooks/useFeedbackMessages';

interface IProps {
    siteId: number;
    show: boolean;
    handleClose: () => void;
}

function FeedbackMessageView({ siteId, show, handleClose }: IProps) {
    const [message, setMessage] = React.useState('');
    const lang = localStorage[LANGUAGE] || 'sv-SE';

    const { data: siteInfoDetails } = useSiteInfoDetails(siteId, lang);
    const sendFeedbackMutation = useSendFeedbackMessage();

    function sendMessage(e: React.MouseEvent) {
        e.preventDefault();
        const bearer = driverinfosecurity.getBearerTokenFromStorage();
        if (bearer != null) {
            const user = driverinfosecurity.parseJwt(bearer);
            if (user != null && siteInfoDetails) {
                sendFeedbackMutation.mutate({ message, driverId: user.UserId, siteInfo: siteInfoDetails.siteInfo });
            }
        }
    }

    return (
        <Dialog open={show} onClose={() => handleClose()}>
            <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white' }}>
                {i18next.t('feedbackmessage.header')}
            </DialogTitle>
            <DialogContent sx={{ pt: 2 }}>
                {sendFeedbackMutation.isPending
                    ? <Spinner />
                    : sendFeedbackMutation.isSuccess
                        ? <Typography>{i18next.t('feedbackmessage.messagesent')}</Typography>
                        : <>
                            <Typography gutterBottom>{i18next.t('feedbackmessage.body')}</Typography>
                            <TextField
                                id="feedbackMessage"
                                fullWidth
                                multiline
                                rows={8}
                                size="small"
                                placeholder={i18next.t('feedbackmessage.inputplaceholder')}
                                onChange={(e) => setMessage(e.target.value)}
                            />
                          </>
                }
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                {sendFeedbackMutation.isSuccess
                    ? <Button variant="contained" color="primary" onClick={() => handleClose()}>{i18next.t('feedbackmessage.close')}</Button>
                    : <Button variant="contained" color="primary" onClick={sendMessage}>{i18next.t('feedbackmessage.button')}</Button>
                }
            </DialogActions>
        </Dialog>
    );
}

export default FeedbackMessageView;
